import { render, staticRenderFns } from "./icon_with_label.vue?vue&type=template&id=31bd761b"
import script from "./icon_with_label.vue?vue&type=script&lang=js"
export * from "./icon_with_label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports